// Marca um erro de mutation/query do Curio como já notificado ao usuário (por useCurioMutation
// ou queryClient.ts). Quando um chamador faz `await mutateAsync(...)` sem try/catch, a rejeição
// sobe até o listener global de unhandledrejection (NotificationProvider.tsx); essa flag permite
// que ele ignore o erro em vez de mostrar uma segunda notificação genérica, sobrescrevendo a correta.
const CURIO_HANDLED_FLAG = "__curioHandled";

export const markCurioHandledError = (error: unknown): void => {
  if (typeof error === "object" && error !== null) {
    Object.assign(error, { [CURIO_HANDLED_FLAG]: true });
  }
};

export const isCurioHandledError = (error: unknown): boolean =>
  typeof error === "object" && error !== null && CURIO_HANDLED_FLAG in error;
